'use client'
import { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import { useAudienceVisitorsTableMapState } from "./AudienceVisitorsTableMapState"
import { FilterByProduct } from "./FilterByProduct"
import { useGlobal } from "@/migrated-widgets/table-map/contexts/GlobalState"

const MapHeader: React.FC<{}> = () => {
    const { distinctProducts } = useAudienceVisitorsTableMapState();
    const { params } = useGlobal();
    const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(null);


    const targetId = `widget-filters-portal-${params.widgetId}`;

    useEffect(() => {
        const container = document.getElementById(targetId);
        setPortalContainer(container);
    }, [targetId]);

    if (!distinctProducts.length) return null;

    const content = (
        <div className="flex justify-end items-center gap-3">
            <FilterByProduct />
        </div>
    );

    if (portalContainer) {
        return createPortal(content, portalContainer);
    }

    return (
        <header className="box-border p-4 pr-6 w-full flex justify-end items-center border-b border-table-map-lightGray">
            {content}
        </header>
    );
}

export { MapHeader }
